import Header from "../components/Header-2";
import ImgMasonry from "../components/Masonry";

const images = [
  "/Street/chair_light_XkQwTkRdx.jpg",
  "/Street/DSC_3777_3736_2UFuXk36o.webp",
  "/Street/DSC_4024_3909_NwUIaaz_p.webp",
  "/Street/hoops_6nUFWqXcA.jpg",
  "/Street/toronto_street_ZejET7I7j.webp",
  "/Street/NY_DSC3782-2_EJ0dLgRqv.webp",
  "/Street/NY_DSC3849-2_DwHmkJZuM.webp",
  "/Street/NY_DSC3786_8_LAMeQfP.webp",
  "/Street/NY_DSC3804__CwkOzFr3.webp",
];

const StreetGrid = () => {
  return (
    <div className="dark:bg-[#201c1c] h-screen">
      <Header />
      <ImgMasonry images={images} />
    </div>
  );
};

export default StreetGrid;
